/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import successPayment from "./assets/payment_success.png";
import successPaymentSM from "./assets/mob_1.png";
import megaphone from "./assets/megaphone.png";
import greenCheck from "./assets/greenCheck.png";
import PrimaryLogo from "./assets/Primary_Logo.png";
import catalyst from "./assets/catalyst_logo.png";
import "./SuccessPayment.css";
import makeStyles from "@mui/styles/makeStyles";
import { useTheme, useMediaQuery } from "@mui/material";
import ShareLink from "./ShareLink";
import { useState } from "react";
import Loader from "./Loader/Loader";
import TagManager from "react-gtm-module";
import SuccessPage from "./SuccessPage";
import ErrorPage from "./ErrorPage";
import { appStoreLink, playStoreLink } from "./utils/constant";

const useStyles = makeStyles((theme) => ({
  root: {
    fontFamily: "Poppins",
    height: "100vh",
  },
  homeLink: {
    textDecoration: "none",
    color: "#FF712D",
    textTransform: "uppercase",
    fontWeight: "bold",
    "&:hover": {
      color: "#FF712D",
    },
  },
  container: {
    position: "relative",
    marginTop: "25px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    fontFamily: "Poppins",
    color: "#555555",
  },
  futureInnovators: {
    position: "absolute",
    fontWeight: "bold",
    padding: "10px",
    backgroundColor: "#FFEDE0",
    width: "80%",
    zIndex: 2,
    borderRadius: "12px",
    top: "-15px",
    fontSize: "18px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
  referral: {
    border: "1px solid #FFE1CC",
    boxShadow: "0px 1px 8px rgba(129, 11, 11, 0.08)",
    borderRadius: "12px",
    zIndex: 1,
    padding: "60px 20px 20px 20px",
    [theme.breakpoints.down("sm")]: {
      padding: "50px 20px 20px 20px",
    },
  },
  share: {
    width: "100%",
  },
  highlight: {
    color: "#0D6EFD",
    fontWeight: "bold",
  },
  megaphone: {
    [theme.breakpoints.up("sm")]: {
      marginRight: "10px",
    },
  },
  cyLogo: {
    background: "#FCFCFC",
    boxhadow: "0px 2px 12px rgba(0, 0, 0, 0.08)",
  },
  catalystColor: {
    color: "#4917B0",
    fontWeight: "bold",
  },
}));
const SuccessPayment = ({ id }) => {
  const theme = useTheme();
  const [referralLink, setReferralLink] = useState();
  const {
    REACT_APP_URL,
    REACT_APP_ONBOARDING_REDIRECT_URL,
    REACT_APP_CHECKOUT_URL,
    REACT_APP_STUDENTPORTAL_URL,
  } = process.env;
  const [loading, setLoading] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState({});

  const getData = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${REACT_APP_URL}/checkPayment`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ paymentId: id }),
      });
      if (!response.ok) {
        throw new Error("Something went Wrong");
      }

      const data = await response.json();
      setPaymentDetails(data);
      setLoading(false);
      setReferralLink(data?.referralUrl);
      successPageGTM(data?.parentContact);
    } catch (error) {
      setLoading(false);
    }
  };

  // const submitOnboardingRequest = async () => {
  //   try {
  //     // This is not applicable for catalyst
  //     if (businessUnitId == 2) {
  //       return;
  //     }
  //     setLoading(true);
  //     setShowRedirectPopup(true);
  //     const response = await fetch(`${REACT_APP_URL}/student/onboarding`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Accept: "application/json",
  //       },
  //       body: JSON.stringify({ paymentId: id, onPaymentSuccess: 1 }),
  //     });
  //     if (response.ok) {
  //       const data = await response.json();
  //       setTimeout(() => {
  //         window.location.href =
  //           REACT_APP_ONBOARDING_REDIRECT_URL +
  //           "/onboarding/" +
  //           data?.requestId;
  //       }, 1500);
  //     }
  //     setLoading(false);
  //   } catch (error) {
  //     setLoading(false);
  //   }
  // };

  const successPageGTM = (parentContact) => {
    const tagManagerArgs = {
      gtmId: "GTM-TH4RWGG",
      dataLayer: {
        event: "codeyoung_site",
        event_category: "codeyoung_site",
        event_action: "payment_success",
        event_label: parentContact,
      },
    };
    TagManager.dataLayer(tagManagerArgs);
    TagManager.initialize(tagManagerArgs);
  };
  useEffect(() => {
    getData();

    if (window.localStorage.getItem("orderFlowName") === "liveClasses") {
      window.localStorage.removeItem("orderFlowName");
      window.location.href = `${REACT_APP_CHECKOUT_URL}/liveclasses?showSuccess=true&paymentId=${id}`;
      return;
    }
    if (window.localStorage.getItem("orderFlowName") === "buyCredits") {
      window.localStorage.removeItem("orderFlowName");
      window.location.href = `${REACT_APP_STUDENTPORTAL_URL}/#/buy-credits?showSuccess=true&paymentId=${id}`;
      return;
    }
    if (window.opener) {
      window.opener.postMessage(
        "paymentSuccess",
        process.env.REACT_APP_WEBSITE_URL
      );
    }

   // submitOnboardingRequest();
  }, []);
  if (loading) return <Loader />;
  return (
    paymentDetails?.tokenAmountStatus === true ? (
        <SuccessPage
          amountPaid={paymentDetails?.paymentAmount}
          dateAndTime={paymentDetails?.paymentDate}
          appStoreLink={appStoreLink}
          playStoreLink={playStoreLink}
          referralLink={referralLink}
          bannerImg={paymentDetails?.banners}
          referralCode={paymentDetails?.referralCode}
          parentId={paymentDetails?.parentId}
        />
      ) : (
        <ErrorPage />
      )
  );
};

export default SuccessPayment;

// return (
//   <Router>
//     {message ? (
//       <Message message={message} id={id} />
//     ) : (
//       <Switch>
//         <Route path="/:success/:transactionId">
//           <Success />
//         </Route>
//         <Route path="/payment-expiry">
//           <PaymentExpiry />
//         </Route>
//         <Route exact path="/failed/:id">
//           <FailedPayment />
//         </Route>
//         <Route exact path="/:id" component={ProductDisplay} />
//       </Switch>
//     )}
//   </Router>
// );
